import { lazy } from 'react';
import { Route } from '../interfaces';
import {
  ChallengeResetPassword,
  ForgotPassword,
  SignIn,
  OTP,
  ResetPassword,
  TwoFactorAuthenConfirm,
} from '../pages/noAuthenPages';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from './routes';
import PasswordComplexity from '@/pages/noAuthenPages/PasswordComplexity';

const AppRoot = lazy(() => import('@/components/AppRoot'));

const publicRoutes: Route[] = [
  { path: PUBLIC_ROUTES.SIGN_IN, component: SignIn },
  { path: PUBLIC_ROUTES.RESET_PASSWORD, component: ResetPassword },
  { path: PUBLIC_ROUTES.FORGOT_PASSWORD, component: ForgotPassword },
  { path: PUBLIC_ROUTES.PASSWORD_COMPLEXITY, component: PasswordComplexity },
  {
    path: PUBLIC_ROUTES.CHALLENGE_RESET_PASSWORD,
    component: ChallengeResetPassword,
  },
  { path: PUBLIC_ROUTES.TWO_FACTOR_CONFIRM, component: TwoFactorAuthenConfirm },
  { path: PUBLIC_ROUTES.OTP, component: OTP },
];

const privateRoutes: Route[] = [
  { path: PRIVATE_ROUTES.APP, component: AppRoot },
];

export { privateRoutes, publicRoutes };
